import { Layers } from "appworks/graphics/layers/layers";
import { ControlFactory } from "appworks/ui/factories/control-factory";
import { AgsAutoplayStartButtonControl } from "../ags-autoplay-start-button-control";

export class AgsAutoplayStartButtonControlFactory implements ControlFactory {
    public filter(layer: Layers): boolean {
        return (
            layer.getFlexiButton("ukgc_autoplay_start_button") != null &&
            layer.getSprite("ukgc_loss_limit_flashing_sprite") != null
        );
    }

    public build(layer: Layers): AgsAutoplayStartButtonControl[] {
        return [
            new AgsAutoplayStartButtonControl(
                layer.getFlexiButton("ukgc_autoplay_start_button"),
                layer.getSprite("ukgc_loss_limit_flashing_sprite")
            )
        ];
    }
}
